import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { CiacService } from 'src/app/services/http/ciac.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-form-consultas-ciac',
  templateUrl: './form-consultas-ciac.component.html',
  styleUrls: ['./form-consultas-ciac.component.scss']
})
export class FormConsultasCiacComponent implements OnInit {

  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    descricao: new FormControl('', [Validators.required]),
    insumo: new FormControl(''),
    codigo: new FormControl('')
  });

  id;
  idInsumos = 0;
  listaInsumos = [];

  constructor(private ciacService: CiacService, private modal: ModalMsgService, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.params.id || null;
    if(this.id) {
      this.ciacService.editConsultaCiac(this.id).then(c => {
        this.form.patchValue(c);
        this.listaInsumos = this.listaInsumos.concat(c['insumos']);
      });
    }
  }

  addInsumos() {
    if(this.form.controls.codigo.value && this.form.controls.insumo.value) {
      this.listaInsumos.push({
        id: this.idInsumos++,
        codigo: this.form.controls.codigo.value, 
        nome: this.form.controls.insumo.value
      });
      this.form.controls.codigo.reset();
      this.form.controls.insumo.reset();
    }
  }

  editInsumo(id) {
    this.listaInsumos.filter(c => {
      if(c.id === id) {
        this.form.controls.codigo.patchValue(c.codigo);
        this.form.controls.insumo.patchValue(c.nome);
        let index = this.listaInsumos.indexOf(c);
        if ( index > -1) {
          this.listaInsumos.splice(index, 1);
        }
      }
    });
  }

  delInsumo(id) {
    this.listaInsumos.filter(c => {
      if(c.id === id) {
        let index = this.listaInsumos.indexOf(c);
        if ( index > -1) {
          this.listaInsumos.splice(index, 1);
        }
      }
    });
  }

  criarJson() {
    let dados;
    if(this.id) {
      let insumos = [];
      this.listaInsumos.forEach(c => {
        let i = { codigo: c.codigo, nome: c.nome }
        insumos.push(i);
      });
      dados = {
        id: parseInt(this.id),
        nome: this.form.controls.nome.value,
        descricao: this.form.controls.descricao.value,
        insumos: insumos
      }
    }else {
      let insumos = [];
      this.listaInsumos.forEach(c => {
        let i = { codigo: c.codigo, nome: c.nome }
        insumos.push(i);
      });
      dados = {
        nome: this.form.controls.nome.value,
        descricao: this.form.controls.descricao.value,
        insumos: insumos
      }
    }
    return dados;
  }

  submitForm() {
    let result = this.criarJson();
    if(this.id) {
      this.ciacService.updateConsultaCiac(result).then(c => {
        if(c.success) {
          this.router.navigate(['ciac', 'consultas', 'listar']);
        }else {
          this.modal.openDialog(
            'Erro ao atualizar consulta',
            'Por favor, verifique os campos e tente novamente.',
            'danger'
          );
          return;
        }
      });
    }else {
      this.ciacService.addConsultaCiac(result).then(c => {
        if(c.success) {
          this.router.navigate(['ciac', 'consultas', 'listar']);
        }else {
          this.modal.openDialog(
            'Erro ao cadastrar consulta',
            'Por favor, verifique os campos.',
            'danger'
          );
          return;
        }
      });
    }
  }
}
